import AsyncWrapper from '@/components/AsyncWrapper';
import Modal from '@/components/Modal';
import PosButton from '@/components/PosButton';
import { requestUserFootprintList } from '@/models/footprint';
import { User } from '@/models/user';
import { getWxSceneDesc } from '@/models/weAppInfo';
import { Style_Display_None } from '@/utils/uiHelper';
import { List, Pagination, Space, Typography } from 'antd';
import { ModalProps } from 'antd/es/modal';
import React, { useEffect } from 'react';
import UserName from '../User/Name';

export type Props = {
  user: User;
  header?: React.ReactNode;
};

export const FootprintList: React.FC<Props> = ({ user, header }: Props) => {
  const { payload, send: getFootprintList, loading, error } = requestUserFootprintList();

  const request = (page = 1) => {
    getFootprintList({
      pathVars: { username: user.username },
      params: { limit: 10, page },
    }).then();
  };

  useEffect(() => {
    if (user && user.username) {
      request(1);
    }
  }, [user]);

  const list = payload?.list;
  const page = payload?.page;
  return (
    <List
      header={header}
      loading={loading}
      itemLayout="horizontal"
      size={'small'}
      pagination={{
        position: 'bottom',
        current: page?.current,
        pageSize: page?.pageSize,
        total: page?.total,
        showSizeChanger: false,
        onChange: page => {
          request(page);
        },
      }}
      dataSource={list}
      renderItem={log => (
        <List.Item>
          <List.Item.Meta
            title={
              <Space size={15}>
                <Typography.Text strong>{log.typeStr}</Typography.Text>
                <Typography.Text type={'secondary'}>{log.addTime}</Typography.Text>
              </Space>
            }
            description={
              <Space direction={'vertical'} size={5}>
                <div>
                  {log.typeIdStr || 'N/A'} | 场景: {getWxSceneDesc(log.wxScene, 'UNK')}
                </div>
              </Space>
            }
          />
        </List.Item>
      )}
    />
  );
};

export const FootprintListModal = ({ user, ...modalProps }: Props & ModalProps) => {
  return (
    <Modal
      title={
        <>
          Trace - <UserName user={user} />
        </>
      }
      destroyOnHidden
      cancelButtonProps={Style_Display_None}
      {...modalProps}
      open={Boolean(user)}>
      <FootprintList user={user} />
    </Modal>
  );
};
